import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Modal} from '@common/core/ui/dialogs/modal.service';
import {ActivatedRoute, Router} from '@angular/router';
import {BiolinksService} from '../biolinks.service';
import {BiolinkWidgetsService} from './widgets/biolink-widgets.service';
import {startWith} from 'rxjs/operators';
import {Toast} from '@common/core/ui/toast.service';
import {Settings} from '@common/core/config/settings.service';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {
    BiolinkEditorService,
    BiolinkEditorTabs,
} from './biolink-editor.service';

@Component({
    selector: 'biolink-editor',
    templateUrl: './biolink-editor.component.html',
    styleUrls: ['./biolink-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BiolinkEditorComponent implements OnInit {
    appearance$ = this.editor.appearanceForm.valueChanges.pipe(startWith({}));

    constructor(
        private modal: Modal,
        private biolinks: BiolinksService,
        private widgets: BiolinkWidgetsService,
        private route: ActivatedRoute,
        private toast: Toast,
        public settings: Settings,
        private router: Router,
        public editor: BiolinkEditorService
    ) {}

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.editor.reloadBiolink(params.linkId);
        });
        this.route.queryParams.subscribe(query => {
            this.editor.activeTab$.next(
                BiolinkEditorTabs[query.tab || 'links']
            );
        });
    }

    tabChanged(e: MatTabChangeEvent) {
        this.router.navigate([], {
            queryParams: {tab: Object.entries(BiolinkEditorTabs)[e.index][0]},
            replaceUrl: true,
        });
    }
}
